export function initThemeToggle() {
    const themeSelector = document.getElementById('theme_selector');
    if (!themeSelector) return;

    // Set initial value based on localStorage
    const currentTheme = localStorage.getItem('theme') || 'system';
    themeSelector.value = currentTheme;

    themeSelector.addEventListener('change', (e) => {
        const selectedTheme = e.target.value;
        if (selectedTheme === 'system') {
            localStorage.removeItem('theme');
            document.documentElement.removeAttribute('data-theme');
        } else {
            localStorage.setItem('theme', selectedTheme);
            document.documentElement.setAttribute('data-theme', selectedTheme);
        }
    });

    // Listen for OS theme changes to update if system is selected
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
        const theme = localStorage.getItem('theme');
        if (!theme || theme === 'system') {
            document.documentElement.removeAttribute('data-theme');
        }
    });
}
